document.addEventListener('DOMContentLoaded', function () {
   const benefitsInner = document.querySelector('.benefits__inner');
   const animate1 = document.querySelector('.qlf-text-animate');

   if (benefitsInner && animate1) {
      const benefitsWrapper = document.querySelector('.benefits_item_wrapper');
      const benefitsInnerWidth = benefitsInner.offsetWidth;
      const benefitsItemWrapperWidth = benefitsWrapper.offsetWidth;

      if (benefitsItemWrapperWidth < benefitsInnerWidth) {
         // clone items to fill the benefits_item_wrapper
         clonedItems = document.querySelector('.benefits_item_wrapper').querySelectorAll('.benefits__text_with_icon');
         clonedItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.classList.add('benefits_item_clone');
            item.parentNode.appendChild(clone);
         });
      }

      // Clone the wrapper to ensure we have enough items to scroll
      const clonedWrapper = benefitsWrapper.cloneNode(true);
      benefitsInner.appendChild(clonedWrapper);

      const baseSpeed = parseFloat(animate1.dataset.animationSpeed) || 8;
      const wrapperWidth = benefitsWrapper.offsetWidth;

      // Calculate a reference width (e.g., desktop width)
      const referenceWidth = 1380; // Adjust this to your typical desktop width

      // Calculate duration proportionally to maintain consistent visual speed
      // If screen is wider, animation takes longer; if narrower, animation is shorter
      const duration = baseSpeed * (wrapperWidth / referenceWidth);

      // Set the CSS variable for the exact pixel width to translate
      benefitsInner.style.setProperty('--ticker-width', `-${wrapperWidth}px`);

      // Apply the animation to the benefits__inner element
      benefitsInner.style.animationDuration = `${duration}s`;
      benefitsInner.style.animationName = 'tickerAnimation';
      benefitsInner.style.animationTimingFunction = 'linear';
      benefitsInner.style.animationIterationCount = 'infinite';
   }
});
